module.exports = __webpack_public_path__ + "img/logo_5.4d6e3033.svg";